import * as React from 'react';
import {FunctionComponent} from 'react';
import {GeoTrack} from '../../../../Models/GeoTrack';
import {GeoPoint} from '../../../../Models/GeoPoint';

interface OwnProps {
    geoTrack: GeoTrack;
    selectedGeoPoint?: GeoPoint;
    onGeoPointChanged: (geoPoint: GeoPoint) => void;
}

export const GeoPointRangeSelector: FunctionComponent<OwnProps> = ({geoTrack, selectedGeoPoint, onGeoPointChanged}) => {
    const geoPointIndex = selectedGeoPoint !== undefined ? geoTrack.indexOf(selectedGeoPoint) : 0;
    return (
        <input
            type="range"
            className="form-range"
            id="activeStrokeNumber"
            value={geoPointIndex === -1 ? 0 : geoPointIndex}
            onChange={(event) => onGeoPointChanged(geoTrack[parseInt(event.target.value, 10)] || undefined)}
            min={0}
            max={geoTrack.length - 1}
            step={1}
        />
    );
};
